const DEFAULT_API_BASE = 'https://tts-apim3.azure-api.net';
const API_BASE = (process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE).replace(/\/$/, '');

const buildUrl = (path) => {
  if (!path.startsWith('/')) {
    return `${API_BASE}/${path}`;
  }
  return `${API_BASE}${path}`;
};

const handleResponse = async (response) => {
  const contentType = response.headers.get('content-type');
  const isJson = contentType && contentType.includes('application/json');
  const payload = isJson ? await response.json() : await response.text();

  if (!response.ok) {
    const errorMessage = typeof payload === 'string' && payload
      ? payload
      : payload?.error_message || 'Request failed';
    throw new Error(errorMessage);
  }

  return payload;
};

export const uploadLecture = async (formData, metadata) => {
  if (metadata && typeof metadata === 'object') {
    const sanitized = Object.entries(metadata).reduce((acc, [key, value]) => {
      if (value !== undefined) acc[key] = value;
      return acc;
    }, {});

    if (Object.keys(sanitized).length > 0) {
      formData.append('metadata', JSON.stringify(sanitized));
    }
  }

  const response = await fetch(buildUrl('/stt/upload'), {
    method: 'POST',
    body: formData,
    credentials: 'include',
  });

  return handleResponse(response);
};

export const getStatusByRequestId = async (requestId) => {
  if (!requestId) {
    throw new Error('request_id is required');
  }

  const response = await fetch(buildUrl(`/stt/status?request_id=${encodeURIComponent(requestId)}`), {
    method: 'GET',
    credentials: 'include',
  });

  return handleResponse(response);
};

export const getStatusByLectureId = async (lectureId) => {
  if (!lectureId) {
    throw new Error('lectureId is required');
  }

  const url = buildUrl(`/stt/status?context_type=lecture&context_id=${encodeURIComponent(lectureId)}`);
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
  });

  return handleResponse(response);
};

export const getLectureList = async (limit = 10) => {
  const parsedLimit = Number(limit);
  const search = Number.isFinite(parsedLimit) ? `?limit=${parsedLimit}` : '';
  const response = await fetch(buildUrl(`/stt/list${search}`), {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return handleResponse(response);
};


// Create STT Support Ticket
export const createSupportTicket = async (payload) => {
  const response = await fetch(buildUrl('/support'), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response);
};

